const GET_RECOM_VIDEOS_LOADING = 'GET_RECOM_VIDEOS_LOADING';
const GET_RECOM_VIDEOS_SUCCESS = 'GET_RECOM_VIDEOS_SUCCESS';
const GET_RECOM_VIDEOS_ERROR = 'GET_RECOM_VIDEOS_ERROR';

export {
  GET_RECOM_VIDEOS_LOADING,
  GET_RECOM_VIDEOS_SUCCESS,
  GET_RECOM_VIDEOS_ERROR
};
